import React from 'react';

import { IconNames, Icons } from '@/constants/icons';

interface IconProperties {
  className?: string;

  viewBox?: string;

  title?: string;

  style?: any;

  role?: string;

  size?: '12' | '14' | '16' | '20' | '24' | '32' | '40';

  name: IconNames;
}

const Icon: React.FC<IconProperties> = ({
  viewBox = '0 0 16 16',
  title,
  size = '16',
  name,
  role = 'img',
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox={viewBox}
    role={role}
    {...props}
    fill="currentColor"
  >
    {title && <title>{title}</title>}
    {Icons[name]()}
  </svg>
);

export default Icon;
